<template>

<div class="absolute inset-0 z-10 flex items-center justify-center w-full h-full">
  <div class="bg-white lg:space-y-5 max-w-screen-lg mx-auto md:p-8 p-6 space-y-3.5 text-center w-full border-2 border-dashed shadow-2xl h-80 flex flex-col justify-center">
    <!-- - Title -->
    <div class="text-3xl font-extrabold md:text-4xl xl:text-5xl font-ww-medium text-lifeboost-red">Subscriptions Maintenance</div>
    <!-- - Subtitle -->
    <p class="max-w-6xl mx-auto text-base md:text-lg lg:text-2xl">We're currently performing maintenance to improve your experience. <br />Subscriptions will be back online shortly.</p>
  </div>
</div> 

</template>